export default __webpack_public_path__ + "static/media/img-0756-slovenia-full-face.75a34434.png";